(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var memory = {};

  class VrReviewWall extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.reviews = [];
      this.visible = 0;
      this.batch = Number(this.dataset.batch || 9);
      this.min = Number(this.dataset.min || 1);
      this.filterPics = false;
      this.sort = 'new';
      this.started = false;
      var scope = this.closest('.vr-section') || document;
      this.toggle = scope.querySelector('[data-vr-wall-toggle]');
      if (!this.toggle) return;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            io.disconnect();
            self.preload().catch(function () {});
          }
        }, { rootMargin: '1500px 0px' });
        io.observe(scope);
      } else {
        setTimeout(function () { self.preload().catch(function () {}); }, 2500);
      }
      this.toggle.addEventListener('click', function () {
        var opening = self.hidden;
        self.hidden = !opening;
        self.toggle.textContent = opening ? self.toggle.dataset.labelClose : self.toggle.dataset.labelOpen;
        self.toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) {
          if (!self.started) self.start();
          self.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    preload() {
      if (this.promise) return this.promise;
      this.promise = this.load();
      return this.promise;
    }

    start() {
      var self = this;
      this.started = true;
      this.status = this.querySelector('[data-status]');
      this.list = this.querySelector('[data-list]');
      this.more = this.querySelector('[data-more]');
      this.picsBtn = this.querySelector('[data-filter-pics]');
      this.sortSel = this.querySelector('[data-sort]');
      if (!this.bound) {
        this.bound = true;
        this.bindControls();
      }
      this.status.textContent = this.dataset.loading || '';
      this.list.classList.add('is-loading');
      this.preload().then(function () {
        self.list.classList.remove('is-loading');
        self.visible = self.batch;
        self.render();
      }).catch(function () {
        self.fail();
      });
    }

    bindControls() {
      var self = this;
      this.more.addEventListener('click', function () { self.visible += self.batch; self.render(true); });
      this.picsBtn.addEventListener('click', function () {
        self.filterPics = !self.filterPics;
        self.picsBtn.setAttribute('aria-pressed', self.filterPics ? 'true' : 'false');
        self.picsBtn.classList.toggle('is-on', self.filterPics);
        self.visible = self.batch;
        self.render();
      });
      this.sortSel.addEventListener('change', function () {
        self.sort = self.sortSel.value;
        self.visible = self.batch;
        self.render();
      });
    }

    fail() {
      this.promise = null;
      this.started = false;
      this.list.classList.remove('is-loading');
      var key = this.dataset.fallback;
      var target = key ? document.querySelector('[id^="shopify-section-"][id$="__' + key + '"]') : null;
      if (target) {
        target.classList.add('vr-open');
        this.hidden = true;
      } else {
        this.status.textContent = this.dataset.error || '';
      }
    }

    clean(name) {
      var strip = this.dataset.strip || '';
      var out = name || '';
      if (strip) out = out.split(strip).join('');
      out = out.replace(/\s+/g, ' ').trim();
      var hide = (this.dataset.hideNames || '').split('|').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      if (!out || hide.indexOf(out.toLowerCase()) > -1) return this.dataset.anon || '';
      return out;
    }

    async load() {
      var shop = this.dataset.shop;
      var cacheKey = this.dataset.product;
      var cached = memory[cacheKey];
      if (cached && Date.now() - cached.t < 600000) {
        this.reviews = this.prepare(cached.list);
        return;
      }
      var base = 'https://api.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&product_id=' + encodeURIComponent(this.dataset.product) + '&per_page=10&page=';
      var self = this;
      var fetchPage = function (page) {
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, 12000);
        return fetch(base + page, { signal: controller.signal }).then(function (res) {
          if (!res.ok) throw new Error('status ' + res.status);
          return res.json();
        }).finally(function () { clearTimeout(timer); });
      };
      var first = await fetchPage(1);
      var total = Number(first.total_count) || 0;
      var pages = Math.min(20, Math.max(1, Math.ceil(total / 10)));
      var rest = [];
      for (var p = 2; p <= pages; p += 1) rest.push(fetchPage(p));
      var results = [first].concat(await Promise.all(rest));
      var all = [];
      var seen = {};
      results.forEach(function (json) {
        var doc = new DOMParser().parseFromString(json.html || '', 'text/html');
        doc.querySelectorAll('.jdgm-rev').forEach(function (node) {
          var rid = node.getAttribute('data-review-id');
          if (rid) { if (seen[rid]) return; seen[rid] = 1; }
          all.push(self.parse(node));
        });
      });
      if (!all.length && total > 0) throw new Error('empty');
      memory[cacheKey] = { t: Date.now(), list: all };
      this.reviews = this.prepare(all);
    }

    prepare(all) {
      var min = this.min;
      var out = [];
      all.forEach(function (r) {
        if (r.score >= min) out.push(r);
        else if (r.pics.length) out.push({ id: r.id, score: 0, name: '', title: '', body: '', date: r.date, pics: r.pics, photoOnly: true });
      });
      return out;
    }

    parse(node) {
      var text = function (sel) {
        var el = node.querySelector(sel);
        return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
      };
      var ratingEl = node.querySelector('.jdgm-rev__rating');
      var score = ratingEl ? Number(ratingEl.getAttribute('data-score')) || 0 : 0;
      var body = text('.jdgm-rev__body');
      if (/^\(photo only\)$/i.test(body)) body = '';
      var pics = [];
      node.querySelectorAll('.jdgm-rev__pic-link').forEach(function (a) {
        var href = a.getAttribute('data-mfp-src') || a.getAttribute('href') || '';
        if (href.indexOf('https://review-images.judgeme.com/') !== 0) return;
        pics.push({ full: href, thumb: href.replace(/width=\d+/, 'width=360') });
      });
      var time = node.querySelector('time');
      return {
        id: node.getAttribute('data-review-id'),
        score: score,
        name: this.clean(text('.jdgm-rev__author')),
        title: text('.jdgm-rev__title'),
        body: body,
        date: time && time.getAttribute('datetime') ? new Date(time.getAttribute('datetime')) : null,
        pics: pics
      };
    }

    sorted() {
      var onlyPics = this.filterPics;
      var list = this.reviews.filter(function (r) { return !onlyPics || r.pics.length; });
      var t = function (r) { return r.date ? r.date.getTime() : 0; };
      if (this.sort === 'high') list.sort(function (a, b) { return (b.photoOnly ? -1 : b.score) - (a.photoOnly ? -1 : a.score) || t(b) - t(a); });
      else if (this.sort === 'low') list.sort(function (a, b) { return (a.photoOnly ? 9 : a.score) - (b.photoOnly ? 9 : b.score) || t(b) - t(a); });
      else list.sort(function (a, b) { return t(b) - t(a); });
      return list;
    }

    card(r) {
      var self = this;
      var anon = this.dataset.anon || '';
      var el = document.createElement('article');
      el.className = 'vr-wcard' + (r.photoOnly ? ' vr-wcard--photos' : '');
      var head = document.createElement('div');
      head.className = 'vr-wcard__head';
      var avatar = document.createElement('span');
      avatar.className = 'vr-wcard__avatar';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.textContent = (Array.from(r.name || anon || '?')[0] || '?').toUpperCase();
      var who = document.createElement('div');
      who.className = 'vr-wcard__who';
      var strong = document.createElement('strong');
      strong.textContent = r.name || anon;
      var when = document.createElement('time');
      if (r.date && !isNaN(r.date)) when.textContent = r.date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      who.appendChild(strong);
      who.appendChild(when);
      var stars = document.createElement('span');
      stars.className = 'vr-stars vr-wcard__stars';
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', r.score + ' out of 5 stars');
      stars.textContent = '★★★★★'.slice(0, r.score) + '☆☆☆☆☆'.slice(0, 5 - r.score);
      head.appendChild(avatar);
      head.appendChild(who);
      head.appendChild(stars);
      if (!r.photoOnly) el.appendChild(head);
      if (r.title) {
        var h = document.createElement('h4');
        h.className = 'vr-wcard__title';
        h.textContent = r.title;
        el.appendChild(h);
      }
      if (r.body) {
        var p = document.createElement('p');
        p.className = 'vr-wcard__text';
        p.textContent = r.body;
        el.appendChild(p);
      }
      if (r.pics.length) {
        var row = document.createElement('div');
        row.className = 'vr-wcard__pics';
        r.pics.forEach(function (pic, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'vr-wcard__pic';
          b.setAttribute('aria-label', 'Open photo ' + (n + 1));
          var img = document.createElement('img');
          img.src = pic.thumb;
          img.alt = '';
          img.loading = 'lazy';
          b.appendChild(img);
          b.addEventListener('click', function () {
            window.VRLightbox.open(r.pics.map(function (x) { return { src: x.full, alt: self.dataset.photoAlt || '' }; }), n, b);
          });
          row.appendChild(b);
        });
        el.appendChild(row);
      }
      return el;
    }

    render(append) {
      var list = this.sorted();
      var self = this;
      var from = append ? this.list.children.length : 0;
      if (!append) this.list.textContent = '';
      list.slice(from, this.visible).forEach(function (r) { self.list.appendChild(self.card(r)); });
      var shown = Math.min(this.visible, list.length);
      var real = list.filter(function (r) { return !r.photoOnly; }).length;
      var shownReal = list.slice(0, shown).filter(function (r) { return !r.photoOnly; }).length;
      this.status.textContent = list.length ? (this.dataset.showing || '').replace('[a]', shownReal).replace('[b]', real) : (this.dataset.empty || '');
      this.more.hidden = shown >= list.length;
    }
  }

  if (!customElements.get('vr-review-wall')) customElements.define('vr-review-wall', VrReviewWall);
})();
